export const gradient = (id: string, startColor: string, endColor: string) => {
  return (
    <defs>
      <linearGradient id={id} x1='0%' y1='0%' x2='0%' y2='100%'>
        <stop offset='0%' stopColor={startColor} />
        <stop offset='100%' stopColor={endColor} />
      </linearGradient>
    </defs>
  );
};
